export default __webpack_public_path__ + "static/media/Equilibrio pirandelliano.43d5d0cc.jpg";